<template>
  <div class="g-layout" ref="mainContainer">
    <ic-header :menu-list="menuList"></ic-header>
    <div class="g-layout-main" v-if="loaded">
      <router-view></router-view>
    </div>
    <ic-tool></ic-tool>
    <feature-footer></feature-footer>
  </div>
</template>

<script>
import Header from "_c/Header";
import Footer from "./Footer";
import Tool from "_c/Tool";
import { Loading } from "element-ui";
import { mapState, mapActions } from "vuex";
import Vue from "vue";
export default {
  name: "feature-layout",
  data() {
    const site = `/feature-${this.$route.params.site}`;
    return {
      menuList: [
        { name: "首页", link: `${site}` },
        { name: "学院概况", link: `${site}/intro/base` },
        { name: "专业信息", link: `${site}/major` },
        { name: "招工招生", link: `${site}/ah/admission` },
        { name: "社会服务", link: `${site}/ss/society` },
        { name: "创新创业", link: `${site}/innovation` },
        { name: "成果转化", link: `${site}/achievement/show` }
      ],
      loaded: false,
      theme: "default"
    };
  },
  components: {
    [Header.name]: Header,
    [Footer.name]: Footer,
    [Tool.name]: Tool
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  async mounted() {
    console.log(123, this.collegeData);
    let loadingOptions = {
      target: this.$refs.mainContainer,
      fullscreen: false
    };
    let loadingInstance = Loading.service(loadingOptions);
    if (!this.collegeData) {
      console.log("go Init");
      await this.setCollegeData();
      this.loaded = true;
    } else {
      this.loaded = true;
    }
    //根据学院换主题
    // this.theme = "light-blue";
    // switch (this.$route.params.site) {
    //   //需要补全完善
    //   case "gslc":
    //     this.theme = "dark-blue";
    //     break;
    //   case "gtzh":
    //     this.theme = "dark";
    //     break;
    //   case "bsd":
    //     this.theme = "green";
    //     break;
    //   case "ylhl":
    //     this.theme = "purple";
    //     break;
    //   default:
    //     break;
    // }
    // this.$store.dispatch("settings/changeTheme", this.theme);
    loadingInstance.close();
  },
  methods: {
    ...mapActions("college", ["setCollegeData"])
  },
  watch: {
    $route() {
      Vue.prototype.$subsitePrefix = window.G_SubsiteProfix = `/feature-${this.$route.params.site}`;
    }
  },
  created() {
    Vue.prototype.$subsitePrefix = window.G_SubsiteProfix = `/feature-${this.$route.params.site}`;
  }
};
</script>

<style lang="scss" scoped>
.g-layout {
  &-main {
    padding-bottom: 230px;
  }
  ::v-deep .comp-header {
    .top .left {
      // background-image: url(~assets/img/feature/logo-bsd.png);
      // width: 208px;
    }
    // .nav {
    //   box-shadow: 0px 4px 8px 0px rgba(69, 80, 238, 0.1);
    //   .g-wrap a {
    //     color: #333;
    //     &.router-link-exact-active,
    //     &:hover {
    //       border-color: transparent;
    //       color: $primary-color;
    //     }
    //   }
    // }
  }
}
</style>
